import Product = FBInstant.Product;
import Purchase = FBInstant.Purchase;
import { ISDKpayments, ProductId, PurchaseStatus, PurchaseToken } from './ISDKpayments';
import { disableIAP } from '../Utils/Platform';

export class SDKfbpayments implements ISDKpayments {
    public readonly enabled: boolean;
    private readonly readyPromise: Promise<void>;

    constructor() {
        this.enabled =
            FBInstant.getSupportedAPIs().includes('payments.purchaseAsync') && !disableIAP();
        if (this.enabled) {
            this.readyPromise = new Promise<void>(resolve => {
                FBInstant.payments.onReady(() => {
                    resolve();
                });
            });
        } else {
            this.readyPromise = Promise.reject('IAP not supported.');
            this.readyPromise.catch(() => {});
        }
    }

    public async getCatalog(): Promise<Product[]> {
        try {
            await this.readyPromise;
            return await FBInstant.payments.getCatalogAsync();
        } catch (e) {
            return [];
        }
    }

    public async purchase(productID: ProductId) {
        try {
            await this.readyPromise;
            const purchase = await FBInstant.payments.purchaseAsync({ productID });
            return { status: PurchaseStatus.Success, purchase };
        } catch (e) {
            return {
                status: e.code === 'USER_INPUT' ? PurchaseStatus.Cancelled : PurchaseStatus.Error,
            };
        }
    }

    public async getPurchases(): Promise<Purchase[]> {
        try {
            await this.readyPromise;
            return await FBInstant.payments.getPurchasesAsync();
        } catch (e) {
            return [];
        }
    }

    public async consumePurchase(purchaseToken: PurchaseToken) {
        try {
            await this.readyPromise;
            await FBInstant.payments.consumePurchaseAsync(purchaseToken);
            return true;
        } catch (e) {
            return false;
        }
    }
}
